import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { archiveModalVar } from "../../../graphql/globalVar/state";
import { useEventActions } from "../../../hooks/useEventActions";

function ArchiveModal() {
  const eventId = useReactiveVar(archiveModalVar);
  const { t } = useTranslation();
  const { archiveEvent, archiveLoading } = useEventActions();

  return (
    <Modal
      show={eventId !== null}
      onHide={() => archiveModalVar(null)}
      centered
      dialogClassName="modal-stop-tickets-sale"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3">
        <Modal.Title className="fw-bold">
          {t("events.modals.archive.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center text-muted p-3 px-4 fs-6">
        <p className="fs-6 text-dark m-0 px-1 px-md-0">
          {t("events.modals.archive.body")}
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0">
        <Row className="g-2 w-100 m-0">
          <Col xs={4} md={6}>
            <Button
              variant="outline-dark"
              className="w-100 py-3 rounded-3 fw-normal"
              onClick={() => archiveModalVar(null)}
              disabled={archiveLoading}
            >
              {t("events.cancel")}
            </Button>
          </Col>
          <Col xs={8} md={6}>
            <Button
              variant="success"
              className="w-100 py-3 rounded-3 text-white"
              onClick={() => eventId && archiveEvent(eventId)}
              disabled={archiveLoading}
            >
              {archiveLoading
                ? t("events.modals.archive.archiving")
                : t("events.modals.archive.confirm")}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default ArchiveModal;
